import { AxiosInstance } from 'axios';
import { requestHandler } from 'services/helpers';
import type {
	ValidatePartnerLoginRequest,
	ValidatePartnerLoginResponse,
	GetPartnerCustomerRequest,
	GetPartnerCustomerResponse,
	GetPartnerVerificationOTPRequest,
	ValidatePartnerVerificationOTPRequest,
	ValidatePartnerSignupOTPResponse,
	ValidatePartnerSignupOTPRequest,
	GetPartnerSignupOTPRequest,
	CreatePartnerCustomerResponse,
} from './interfaces';
import type { ValidatePartnerVerificationOTPResponse, CreateCustomerParams } from '../interfaces';

let api: AxiosInstance;

import('services').then(({ createAPIConnection }) => {
	api = createAPIConnection('/customers/partner');
});

export function getPartnerCustomer({ email, partnerToken: Authorization }: GetPartnerCustomerRequest) {
	return requestHandler<GetPartnerCustomerResponse>(
		api.post('/get-customer', { email }, { headers: { Authorization } }),
		{ throwData: true },
	);
}

export function validatePartnerLogin(payload: ValidatePartnerLoginRequest) {
	return requestHandler<ValidatePartnerLoginResponse>(api.post('/validate', payload), { throwData: true });
}

export function getPartnerSignupOTP({ partnerToken: Authorization, ...payload }: GetPartnerSignupOTPRequest) {
	return requestHandler(api.post('/token/generate', payload, { headers: { Authorization } }), {
		throwData: true,
	});
}

export function validatePartnerSignupOTP({ partnerToken: Authorization, ...payload }: ValidatePartnerSignupOTPRequest) {
	return requestHandler<ValidatePartnerSignupOTPResponse>(
		api.post('/token/validate', payload, { headers: { Authorization } }),
		{
			throwData: true,
		},
	);
}

export function getPartnerVerificationOTP(payload: GetPartnerVerificationOTPRequest) {
	return requestHandler(api.post('/2FA/token/send', payload), {
		throwData: true,
	});
}

export function validatePartnerVerificationOTP(payload: ValidatePartnerVerificationOTPRequest) {
	return requestHandler<ValidatePartnerVerificationOTPResponse>(api.post('/2FA/token/validate', payload), {
		throwData: true,
	});
}

export function createPartnerCustomer({ partnerToken: Authorization, ...payload }: CreateCustomerParams) {
	return requestHandler<CreatePartnerCustomerResponse>(
		api.post('/create-customer', payload, { headers: { Authorization } }),
		{ throwData: true },
	);
}